<template>
    <div id="app">
        <component :is="layout">
            <router-view />
        </component>
    </div>
</template>
<script>
window.location.href = 'https://api.giv.link/admin'
/*
import Layout from './layouts/Default'
import NoSidebar from './layouts/NoSidebar'

export default {
    name: 'App',
    computed: {
        layout() {
            return this.$route.fullPath === '/login' ? NoSidebar : Layout
        },
    },
    components: {
        Layout,
        NoSidebar,
    },
}
*/
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
#app {
    font-family: 'Noto Sans JP', sans-serif;
}
</style>
